<div style="height:30px">
      <b>Appsensor Services</b>
 </div>
  <app-grid-table [popup]="false" id="gridwithsmallwidth" [totalRecords]="appsensorServiceGrid.totalRecords" [selectedColumns]="appsensorServiceGrid.selectedColumns"
   [cols]="appsensorServiceGrid.cols" height="248px" [colData]="appsensorServiceGrid.colData" [org]="org" [dataUrl]="dataUrl" (update)="loadGrid($event)"
    (rowSelect)="rowSelect($event)"  (showGraph)="showGraph($event)" [to]="0">
  </app-grid-table>
 
